
import React from 'react';
import { useNavigate } from 'react-router-dom';
// import { AppUserContext } from '../../App';
import Nav from '../../components/breadcrumb';
import VoucherForm from './voucher-form';

const voucher = {
    method: "",
    account_id: ""
}

const NewVoucher = () => {

    const nav_items = [
        { title: 'Payment Vouchers', href: '/app/payment-vouchers' },
        { title: 'New Requisition' }
    ];

    const navigate = useNavigate();

    const handleSubmit = (details) => {
        navigate(`/app/payment-vouchers/${details.id}`);
    }

    // const { profile } = useContext(AppUserContext);

    // if (profile.roles.indexOf('finance') === -1) {
    //     return <ErrorLoading>You do not have permission to create an expense.</ErrorLoading>;
    // }



    return (
        <>
            <Nav items={nav_items} />

            <VoucherForm
                details={voucher}
                action="create"
                onSubmit={handleSubmit}
            />
        </>
    )
}


/**
 * 
 * @param {Object} props
 * @param {import('../../resources/api/payment-vouchers').PaymentVoucherObject'} props.details 
 * @param {React.Dispatch<React.SetStateAction<import('../../resources/api/payment-vouchers').PaymentVoucherObject>>} props.setDetails 
 */
const EditVoucher = ({ details, setDetails }) => {

    const nav_items = [
        { title: 'Payment Vouchers', href: '/app/payment-vouchers' },
        { title: details.vo, href: `/app/payment-vouchers/${details.id}` },
        { title: 'Edit Details' }
    ];

    const navigate = useNavigate();

    const handleSubmit = (details) => {
        setDetails(d => ({ ...d, ...details }));
        navigate(`/app/payment-vouchers/${details.id}`);
    }

    // const { profile } = useContext(AppUserContext);

    // if (profile.roles.indexOf('finance') === -1) {
    //     return <ErrorLoading>You do not have permission to update an expense.</ErrorLoading>;
    // }


    return (

        <>
            <Nav items={nav_items} />

            <div className="max-800 p-2">
                <VoucherForm
                    details={details}
                    onSubmit={handleSubmit}
                    action="edit"
                />
            </div>
        </>
    )

}


export { EditVoucher };


export default NewVoucher;